<div *ngIf="displayTime > 0">{{ displayTime }} min</div>
